import { rivalLine, type Rival } from '../../app/runPlan';
import { el, setText } from '../components/el';

/** "Chasing Kofi · 1,240 behind" / "Ahead of Kofi by 300", live while you drive. Hidden when nobody's being chased. */
export class RivalTicker {
  private readonly root = el('div', 'rival-ticker');
  private rival: Rival | null = null;

  constructor(parent: HTMLElement) {
    parent.append(this.root);
  }

  set(rival: Rival | null): void {
    this.rival = rival;
    this.root.classList.toggle('show', rival !== null);
    if (!rival) setText(this.root, '');
  }

  update(score: number): void {
    if (!this.rival) return;
    const line = rivalLine(this.rival, score);
    setText(this.root, `${line.ahead ? '🏁' : '🏃'} ${line.text}`);
    this.root.classList.toggle('ahead', line.ahead);
  }
}
